export enum Scope {
    StaffContent = 'ilt.giglets.content.write',
    StaffUsers = 'ilt.giglets.users',
}
export const ScopeValues = Object.values(Scope).map((scope) => scope.toString());
